// @ts-nocheck
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {BaseButton} from "@/components";

const WithdrawalFailure = ({errorMessage, onRetry, onClose}) => {
  const {t} = useTranslation();
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "20px" : "40px",
        textAlign: "center",
        minHeight: "300px",
      }}
    >
      <div
        aria-hidden="true"
        style={{
          fontSize: isMobile ? "64px" : "80px",
          color: "var(--color-danger)",
          marginBottom: "var(--space-5-5)",
          lineHeight: 1,
        }}
      >
        ✕
      </div>

      <h2
        style={{
          fontSize: isMobile ? "20px" : "24px",
          fontWeight: 700,
          margin: "0 0 16px 0",
          color: "var(--color-text-primary)",
        }}
      >
        {t("withdrawalFailureTitle")}
      </h2>

      <p
        style={{
          fontSize: isMobile ? "14px" : "16px",
          color: "var(--color-text-secondary)",
          margin: "0 0 8px 0",
          maxWidth: "400px",
        }}
      >
        {t("withdrawalFailureMessage")}
      </p>

      {errorMessage && (
        <p
          style={{
            fontSize: isMobile ? "12px" : "14px",
            color: "var(--color-danger-text)",
            margin: "0 0 32px 0",
            maxWidth: "400px",
            fontStyle: "italic",
          }}
        >
          {errorMessage}
        </p>
      )}

      <div
        style={{
          display: "flex",
          gap: "var(--space-4-5)",
          flexDirection: isMobile ? "column" : "row",
          width: isMobile ? "100%" : "auto",
        }}
      >
        <BaseButton
          variant="primary"
          size="lg"
          onClick={onRetry}
          className="btn-tertiary-hover"
          style={{minWidth: "150px"}}
        >
          {t("withdrawalFailureRetry")}
        </BaseButton>

        <BaseButton
          variant="secondary"
          size="lg"
          onClick={onClose}
          className="btn-secondary-hover"
          style={{minWidth: "150px"}}
        >
          {t("withdrawalFailureClose")}
        </BaseButton>
      </div>
    </div>
  );
};

WithdrawalFailure.propTypes = {
  errorMessage: PropTypes.string,
  onRetry: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WithdrawalFailure;
